import { useTranslation } from "react-i18next";

import { useFaq } from "context/client/faq";

import Table from "components/Table";

const FaqTable = () => {
  const { t } = useTranslation();

  const { dataSorted, filter, sort, setSort, setSelected } = useFaq();

  const table_data = {
    keys: [
      {
        key: "category",
        sort_key: filter === "" ? "category" : false,
        value: t("Category"),
      },
      {
        key: "issue",
        sort_key: "issue",
        value: t("Issue"),
      },
      {
        key: "details",
        sort_key: false,
        value: t("Details"),
      },
    ],
    items: dataSorted.map((item) => {
      const slug = item.category.slug;
      const title = item.title;
      const category = {
        label: item.category.title,
        color:
          slug === "payments-and-subscriptions"
            ? "blue"
            : slug === "referral-program"
              ? "green"
              : "yellow",
      };

      return [
        {
          key: "category",
          type: "pill",
          value: {
            data: category,
          },
        },
        {
          key: "issue",
          type: "issue",
          value: title,
        },
        {
          key: "details",
          type: "clickable_text",
          value: {
            label: t("View"),
            onclick: () =>
              setSelected({
                title,
                category,
                content: item.content,
              }),
          },
        },
      ];
    }),
  };

  return <Table data={table_data} sort={sort} setSort={setSort} />;
};

export default FaqTable;
